import {
  DESKTOP_NAV_BAR_HEIGHT_PX,
  MOBILE_NAV_BAR_HEIGHT_PX,
} from '@features/navigation/nav-consts';
import Box, { BoxProps } from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import { useGetPageSize } from '@src/hooks';
import { PropsWithChildren } from 'react';

export function BrandedBackgroundContainer(props: PropsWithChildren<BoxProps>) {
  const { isMobile } = useGetPageSize();
  return (
    <Box
      id='branded-background-container'
      display='flex'
      justifyContent='center'
      alignItems='start'
      flex={1}
      overflow='auto'
      {...props}
      sx={{
        background: (theme: Theme) => theme.customGradients.primary,
        height: `calc(100vh - ${isMobile ? MOBILE_NAV_BAR_HEIGHT_PX : DESKTOP_NAV_BAR_HEIGHT_PX})`,
        overflow: 'auto',
        width: '100%',
      }}
    >
      {props.children}
    </Box>
  );
}
